import request from "@/services/request";
import store from "@/store";
import Table from "@/utils/Table";

async function getAllGroupedKcpIndicatorsRegion() {
  try {
    const res = await request({
      endpoint: `/api/indicators/kcp_result_sum_reg?regionId=${store.getters['keycloak/userId']}`,
      method: 'get',
    });
    let sumRow = {id: null, orgId: null, orgName: 'Всего', ownerId: null, qkcpo: 0, qkcpv: 0, qkcpz: 0}
    if (res.status === 200) {
      let returnData = [];
      returnData.push(
        {
          regionName: res.data[0].regionName,
          regionId: res.data[0].regionId,
          orgId: res.data[0].orgId,
          id: Math.random(),
          orgFlag: true
        }
      )
      res.data.forEach(el => {
        sumRow.qkcpo += el.qkcpo;
        sumRow.qkcpv += el.qkcpv;
        sumRow.qkcpz += el.qkcpz;
        returnData.push(
          {
            orgName: el.orgName,
            orgId: el.orgId,
            ownerId: el.ownerId,
            id: el.orgId,
            qkcpo: el.qkcpo,
            qkcpv: el.qkcpv,
            qkcpz: el.qkcpz
          }
        );
      });
      returnData.push(sumRow);
      return returnData;
    } else {
      throw new Error('error getAllGroupedKcpIndicatorsRegion');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения общих показателей ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('error getAllGroupedKcpIndicatorsRegion ' + e)
  }
}

async function getAllGroupedKcpIndicatorsStage1Regions(orgId, regionId) {
  try {
    const res = await request({
      endpoint: `/api/indicators/kcp_result_org_reg?orgId=${orgId}&regionId=${regionId}`,
      method: 'get',
    });
    // console.log(res.data)
    if (res.status === 200) {
      let returnData = [];
      let orgOwner;
      let orgFilials;
      const getOwner = await request({
        endpoint: `/api/spr/org/byId/get?orgId=${orgId}`,
        method: 'GET'
      });
      if (getOwner.status === 200) {
        orgOwner = getOwner.data;
      }
      const getFilials = await request({
        endpoint: `/api/spr/org/byOwnerId/get?ownerId=${orgId}`,
        method: 'GET'
      });
      if (getFilials.status === 200) {
        orgFilials = getFilials.data;
      }
      const usls = store.getters['spr/getUsls'];
      const mainOrgData = res.data.filter(el => (el.orgId === orgOwner.id && (
          el.qkcpo24 !== 'NA' || el.qkcpv24 !== 'NA' || el.qkcpz24 !== 'NA'
        )
      ));
      const filialsData = orgFilials.map(el => {
        return res.data.filter(el2 => (el2.orgId === el.id && (
          el2.qkcpo24 !== 'NA' || el2.qkcpv24 !== 'NA' || el2.qkcpz24 !== 'NA'
        )))
      });
      returnData.push(
        {
          orgName: orgOwner.name,
          orgId: orgOwner.id,
          ownerId: orgOwner.id,
          id: Math.random(),
          orgFlag: true
        }
      )
      usls.forEach(el => {
        if (res.data.find(elData => elData.kcpGroup.usl.id === el.id))
          returnData.push({
              id: Math.random(),
              uslName: el.name
            }, ...mainOrgData.filter(elData => elData.kcpGroup.usl.id === el.id).map(elData => {
              return {
                ...elData,
                qkcpo24: elData.qkcpo24 === 'NA' ? null : elData.qkcpo24,
                qkcpv24: elData.qkcpv24 === 'NA' ? null : elData.qkcpv24,
                qkcpz24: elData.qkcpz24 === 'NA' ? null : elData.qkcpz24,
                iokio22: elData.iokio22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokio22, 3, 'float'),
                iokiv22: elData.iokiv22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokiv22, 3, 'float'),
                iokiz22: elData.iokiz22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokiz22, 3, 'float'),
                iowgt22: elData.iowgt22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iowgt22, 3, 'float')
              }
            })
          );
      });
      if (filialsData.length > 0)
        for (const elFilialData of filialsData) {
          if (elFilialData.length === 0)
            continue;

          returnData.push(
            {
              orgName: elFilialData[0].orgName,
              orgId: elFilialData[0].orgId,
              ownerId: elFilialData[0].ownerId,
              id: Math.random(),
              orgFlag: true,
            }
          );
          usls.forEach(el => {
            if (elFilialData.find(elData => elData.kcpGroup.usl.id === el.id))
              returnData.push({
                id: Math.random(),
                uslName: el.name
              }, ...elFilialData.filter(elData => elData.kcpGroup.usl.id === el.id).map(elData => {
                return {
                  ...elData,
                  qkcpo24: elData.qkcpo24 === 'NA' ? null : elData.qkcpo24,
                  qkcpv24: elData.qkcpv24 === 'NA' ? null : elData.qkcpv24,
                  qkcpz24: elData.qkcpz24 === 'NA' ? null : elData.qkcpz24,
                  iokio22: elData.iokio22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokio22, 3, 'float'),
                  iokiv22: elData.iokiv22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokiv22, 3, 'float'),
                  iokiz22: elData.iokiz22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iokiz22, 3, 'float'),
                  iowgt22: elData.iowgt22 === 'NA' ? null : Table.checkValueWithNullAndReturnND(elData.iowgt22, 3, 'float')
                }
              }));
          });

        }
      return returnData;
    } else {
      throw new Error('error getAllGroupedKcpIndicatorsStage1Regions');
    }
  } catch (e) {
    await store.dispatch('notifications/addNotification', {
      notificationStatus: 'error',
      notificationMessage: 'ошибка получения общих показателей ' + ' ' + e,
      timeout: 3000
    }, {root: true});
    throw new Error('error getAllGroupedKcpIndicatorsStage1Regions ' + e)
  }
}


export {
  getAllGroupedKcpIndicatorsRegion,
  getAllGroupedKcpIndicatorsStage1Regions,
};